<template>
  <div id="quicklyAddProject">
    <a-form-model :model="saveVO" ref="addOrUpdateForm" layout="vertical">
      <div style="background: rgba(248,249,251,0.62);border-radius: 4px;padding: 15px 20px;">

        <a-row :gutter="20">
          <a-col :span="16">
            <a-form-model-item prop="name" :rules=" [
                {required: true,message: $t('mansion.project.tableHeader.addNamePlaceholder'),},
                {min: 1, max: 64, message: $t('mansion.addMansion.form.errorTip.textMinLength'), trigger: 'blur'},
              ]" class="required" :label="$t('mansion.project.tableHeader.name')"
            >
              <a-input v-model="saveVO.name"
                       :placeholder="$t('mansion.project.tableHeader.addNamePlaceholder')"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item prop="region" :label="$t('mansion.addMansion.formLabel.regionStr')" :rules="[
                {required: true,message: $t('mansion.addMansion.placeholder.regionStr'),}
              ]" class="required">
              <pt-cascader v-model="regions"
                           :city-datas="cityDatas" change-on-select
                           :placeholder="$t('mansion.addMansion.placeholder.regionStr')"
                           @changeValue="changeRegion"></pt-cascader>
            </a-form-model-item>
          </a-col>
        </a-row>

      </div>
      <div style="margin-top: 30px;">
        <a-form-model-item prop="mansionIds" :rules="[
                {required: true,message: $t('mansion.project.tableHeader.mansion'),}
              ]">
          <div style="display: flex;justify-content: space-between;align-items: center">
            <div style="display: flex;align-items: center">
              <div class="left_dian"></div>
              <div class="left_text">{{$t('mansion.project.tableHeader.number')}}</div>
              <div class="left_req">*</div>
              <div class="left_sub">{{$t('mansion.project.tableHeader.mulAdd')}}</div>
            </div>
            <div>
              <a-button size="small" @click="openSelect">
                <pt-icon type="icon-zengjia"/>
                {{$t('mansion.project.tableHeader.build')}}
              </a-button>
            </div>
          </div>
          <div style="background: rgba(248,249,251,0.62);border-radius: 4px;padding: 15px 20px;">
            <pt-simple-table :description="$t('mansion.project.tableHeader.empty')" :data-source="mansionDatas"
                             :loading="tableLoading">

              <template slot="columns">
                <el-table-column :label="$t('mansion.tableHeader.mansionName')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{scope.row.name}}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('mansion.tableHeader.integrity')">
                  <template slot-scope="scope">
                    {{scope.row.integrity}}%
                  </template>
                </el-table-column>
                <el-table-column :label="$t('mansion.tableHeader.avgTransactionPrice')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.baseRent != 0">{{scope.row.baseRent}}{{scope.row.rentUnitStr}}</span>
                    <span v-else>0.00</span>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('mansion.tableHeader.vacancyRate')">
                  <template slot-scope="scope">
                    {{scope.row.vacancyRate}}%
                  </template>
                </el-table-column>
                <el-table-column :label="$t('baseVO.operate')" align="center" width="100">
                  <template slot-scope="scope">
                    <pt-icon @click.native="deleteIndex(scope.$index)" :title="$t('mansion.project.tableHeader.unbind')" type="icon-quxiaobangding"></pt-icon>
                  </template>
                </el-table-column>
              </template>
            </pt-simple-table>
          </div>
        </a-form-model-item>
      </div>
    </a-form-model>
    <!--    选择大厦-->
    <div>
      <pt-modal :visible="selectModal.visible" :width="800" :title="$t('mansion.project.tableHeader.build')"
                :loading="selectModal.loading" @cancel="closeSelect" @ok="selectOk">
        <div slot="content">
          <div style="position: relative">
            <a-input v-model="searchText" @pressEnter="searchMansion"
                     :placeholder="$t('mansion.project.tableHeader.mansionSearch')"></a-input>
            <a-button @click="searchMansion" style="position: absolute;right: 0px;top: 5px" size="small">
              <pt-icon type="icon-icon-search"></pt-icon>
              {{$t('mansion.project.tableHeader.search')}}
            </a-button>
          </div>
          <div style="display: flex;align-items: center;margin-top: 20px;margin-bottom: 30px;flex-wrap: wrap">
            <div style="font-size: 12px;color: #BEBEBE;margin-right: 20px;">
              {{$t('mansion.project.tableHeader.selected')}}
            </div>
            <div v-for="(item,index) in selectMansionInfos" style="margin-right: 10px;font-size: 14px;color: #4D4D4D;">
              {{item.name}}
            </div>
          </div>
          <a-spin :spinning="searchLoading">
            <div style="background: #FAFBFC;padding: 15px 25px;width: 100%">
                <div v-for="(item,index) in mansionList"
                     :style="selectMansionInfos.indexOf(item) > -1 ?'background: #EBEBEB;':''"
                     style="height: 52px;display: flex;justify-content: space-between;padding-right:20px;align-items: center;border-bottom: 1px solid #E1E1E1;width: 700px;padding-left: 20px;">
                  <a-checkbox :value="item" @change="(e)=>{selectChange(e,item)}" :checked="getChecked(item)" >
                    <span>
                      {{item.name}}
                    </span>
                  </a-checkbox>
                  <div>
                    {{item.citys.toUpperCase()}}
                  </div>
                </div>
              <pt-empty v-if="mansionList.length == 0" :description="$t('key92qingshuruguanjianzisous')"></pt-empty>
            </div>
          </a-spin>
        </div>
      </pt-modal>
    </div>
  </div>
</template>

<script>
  import Api from '@/api/database/mansion'
  import { findCascadingData } from '@/api/sys/datadict'
  export default {
    name: 'AddOrUpdate',
    props: {
      value: {
        type: Object,
        default: ()=>{return {}}
      },
      oldValue:{
        type:Object,
        default:()=>{return {}}
      }
    },
    data() {
      return {
        mansionDatas: [],
        tableLoading: false,
        cityDatas: [],
        regions: [],
        saveVO: {
          name: '',
          region: '',
          mansionIds: []
        },
        selectModal: {
          visible: false,
          loading: false
        },
        searchText: '',
        selectMansionInfos: [],
        selectMansionIdLists: [],
        mansionList: [],
        searchLoading: false
      }
    },
    computed:{
      selectMansionIds(){
        let arr = []
        this.mansionDatas.forEach(data=>{
          arr.push(data.id)
        })
        return arr;
      },
    },
    mounted() {
      this.initOldValue();
      this.initFormData();
      this.init()
    },

    methods: {
      getChecked(item){
        return this.selectMansionIdLists.indexOf(item.id) > -1
      },
      selectChange(e,item){
        if(e.target.checked){
          this.selectMansionInfos.push(item);
          this.selectMansionIdLists.push(item.id);
        }else{
          this.selectMansionInfos.splice(this.selectMansionInfos.indexOf(item),1);
          this.selectMansionIdLists.splice(this.selectMansionIdLists.indexOf(item.id),1);
        }
      },
      initOldValue(){
        if(this.oldValue.id){
          this.saveVO = Object.assign({},this.oldValue)
          this.regions = this.oldValue.region.split(",")
          this.mansionDatas = this.oldValue.mansionList;
          this.saveVO.mansionIds = []
          this.oldValue.mansionList.forEach(data=>{
            this.saveVO.mansionIds.push(data.id)
          })
          console.log(this.saveVO)
        }
      },
      initFormData(){

      },
      init() {
        this.queryCityDataByCity()
      },
      queryCityDataByCity() {//根据城市查询区域位置
        findCascadingData('system.mansion_set.address', 4, undefined).then(res => {
          this.cityDatas = res.data
        })
      },
      searchMansion() {
        if (this.searchText.trim().length == 0) {
          this.mansionList = []
          return
        }
        this.searchLoading = true;
        Api.selectAllByQueryText({ queryText: this.searchText, projectId: -1 }).then(res => {
          this.searchLoading = false
          if (res.code == 1) {
            this.mansionList = res.data.records
            console.log(this.saveVO.mansionIds)
            if(this.mansionList.length == 0){
              this.$message.warning("无结果,请更换关键字搜素")
            }
          }
        }).catch(()=>{
          this.searchLoading = false
        })
      },
      changeRegion(value) {
        this.saveVO.region = value.join(',')
      },
      openSelect() {
        this.selectModal.visible = true
        this.searchText = ''
        this.selectMansionInfos = []
        this.selectMansionIdLists= []
      },
      closeSelect() {
        this.selectModal.visible = false
      },
      selectOk() {
        this.selectMansionInfos.forEach(data => {
          if(this.selectMansionIds.indexOf(data.id) == -1){
            this.mansionDatas.push(data)
            this.saveVO.mansionIds.push(data.id)
          }
        })
        this.$refs.addOrUpdateForm.validateField('mansionIds')
        this.closeSelect()
      },
      deleteIndex(index) {
        let _this = this;
        this.$ptConfirm({
          title: this.$t('mansion.project.tableHeader.unbindTip.title'),
          content: this.$t('mansion.project.tableHeader.unbindTip.content'),
          okType: 'primary',
          onOk() {
            _this.mansionDatas.splice(index, 1)
            _this.saveVO.mansionIds.splice(index,1)
          },
          onCancel() {

          },
        })

      },
      getData() {
        return new Promise((resolve, reject) => {
          this.$refs.addOrUpdateForm.validate().then(res => {
            this.$emit('input', this.saveVO)
            resolve(this.saveVO)
          }).catch(err => {
            console.log("表单验证不通过")
            this.$message.warn('请正确输入表单')
            reject()
          })
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #quicklyAddMansion {
    background: #FFF;
    border-radius: 0 0 4px 4px;
    padding: 30px 20px 10px 20px;
  }

  .left_dian {
    background: #FABE00;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .left_text {
    font-size: 14px;
    color: #333333;
  }

  .left_req {
    font-size: 18px;
    color: #FA6361;
    padding-top: 6px;
    margin-right: 13px;
  }

  .left_sub {
    font-size: 12px;
    color: #bebebe;
  }

  #quicklyAddProject /deep/ .pt-simple-table {
    background-color: transparent !important;

    .el-table, tr, td {
      background-color: transparent !important;
    }
  }
</style>